import { FormArray, FormControl } from '@angular/forms';


import { DateInterval } from 'ib/internetbank-core/ib-components/date-picker/date-interval';
import { Base64 } from 'ib/internetbank-core/ib-models/common-types';
import { ISODateString } from 'ib/internetbank-core/utils/date-utils';

import { Product } from '../../../products/products.model';

export enum SelectAccountChooseTypeEnum {
	ONE_ACCOUNT,
	ALL_ACCOUNTS,
}

export interface ReferencesCreateBase {
	referenceNumber: number;
	referenceName: string;
	products: Array<Product> | null;
	params?: ReferencesCreateBaseParams;
}

export interface ReferencesCreateBaseParams {
	dateFrom?: ISODateString;
	dateTo?: ISODateString;
	dateAll?: boolean | number;
}

export interface ReferencesForm {
	selectAccountChooseType: FormControl<SelectAccountChooseTypeEnum>;
	sourceSelect: FormControl<Product | null>;
	productsWidthCheckboxes: FormArray<FormControl<Product>>;
	period: FormControl<DateInterval>;
	allPeriod: FormControl<boolean>;
}

export interface ReferenceGroupListResponse {
	groups: Array<ReferenceGroup>;
	referencesWithoutGroup: Array<Reference>;
	emptyListText: string | null;
}

export interface ReferenceOrdered {

	/** Идентификатор заказанной справки */
	referenceId: number;

	/** Название справки */
	referenceName: string;

	/** Дата формирования справки */
	createDate: Date;

	/** Дата, до которой хранится справка */
	expireDate: Date;

	/** Наименование продукта */
	caption: string
}

export type GetReferencesOrderedResponse = Array<ReferenceOrdered>

export interface GetReferenceOrderedDocumentResponce {
	document: Base64;
}

export interface ReferenceGroup {
	groupId: number;
	name: string;
	references: Array<Reference> | null;
	multilangReference: Record<ReferenceGroupLanguage, Array<Reference>> | null;
}

export enum ReferenceGroupLanguage {
	rus = 'rus',
	eng = 'eng',
}

export enum ReferenceGroupLanguageName {
	rus = 'Русский',
	eng = 'Английский',
}

export interface Reference {
	referenceName: string;
	referenceNumber: number;
}

export interface ReferenceDetailInfoDTO {
	params: Array<string>; // dateto,datefrom,dateall
	products: Array<Product>;
	quantity: number;
	referenceDescr: string;
	referenceName: string;
	referenceNumber: number;
	byClient: boolean;
}

export interface ReferenceDetailInfo extends Omit<ReferenceDetailInfoDTO, 'params'> {
	params?: ReferenceDetailInfoParams;
}

export interface ReferenceDetailInfoParams {
	dateto?: boolean;
	datefrom?: boolean;
	dateall?: boolean;
	datecurrent?: boolean;
}